import { render, staticRenderFns } from "./WelcomeBox.vue?vue&type=template&id=50378d93&scoped=true&"
import script from "./WelcomeBox.vue?vue&type=script&lang=js&"
export * from "./WelcomeBox.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeBox.vue?vue&type=style&index=0&id=50378d93&prod&scoped=true&lang=css&"
import style1 from "./WelcomeBox.vue?vue&type=style&index=1&id=50378d93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50378d93",
  null
  
)

export default component.exports